import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router'
import { TranslateService } from '@ngx-translate/core';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(public translate: TranslateService, public router: Router) {
    translate.setDefaultLang('en');
    translate.use(translate.getBrowserLang());

    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd) {
          gtag('config', 'G-RHN7WTMS2Z', { 'page_path': event.urlAfterRedirects });
      }
    });
  }
  
  title = this.translate.instant('APP.NAME');
}
